import downloadFromBrowser from '../helpers/downloadFromBrowser';

export default ({ file_any_id, name, onClose, ...props }) => {
  downloadFromBrowser(file_any_id, name);
  onClose();
  return null;
};